import { getApiUrl } from "../config";
import { authClient } from "../auth-client";

export async function apiFetch<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  let token =
    localStorage.getItem("better-auth.session_token") ||
    localStorage.getItem("token");

  if (!token) {
    if (typeof (authClient as any).getToken === "function") {
      token = await (authClient as any).getToken();
    }

    if (!token) {
      const session = await authClient.getSession();
      if (session?.data) {
        const data = session.data as any;
        token = data.token || data.session?.token;
      }
    }

    if (token) {
      localStorage.setItem("better-auth.session_token", token);
    }
  }

  // Detect FormData: let the browser set the Content-Type with the proper boundary
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;

  const headers = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  } as Record<string, string>;

  const response = await fetch(`${getApiUrl()}${path}`, {
    ...options,
    headers,
    credentials: 'include',
  });

  if (!response.ok) {
    let errorMessage = response.statusText;
    try {
      const errorData = await response.json();
      if (typeof errorData.error === "string") {
        errorMessage = errorData.error;
      } else if (errorData.error?.issues) {
        errorMessage = errorData.error.issues
          .map((issue: any) => {
            const path =
              issue.path?.length ? issue.path.join(".") + ": " : "";
            return path + issue.message;
          })
          .join("; ");
      } else if (typeof errorData.message === "string") {
        errorMessage = errorData.message;
      }
    } catch {
      // Not JSON
    }
    throw new Error(errorMessage);
  }

  if (response.status === 204) {
    return {} as T;
  }

  return response.json();
}